import React from 'react';

export default function LoadingScreen() {
  return (
    <div style={{
      textAlign: 'center',
      padding: '40px',
      fontSize: '1.4rem',
      fontWeight: 'bold',
    }}>
      Loading TutorOrca Quiz Platform...
    </div>
  );
}
